import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { path: '/', label: t('nav.home') },
    { path: '/category/dianshiju', label: t('nav.category') },
    { path: '/articles', label: t('nav.article') },
    { path: '/about', label: t('nav.about') },
  ];

  const platformLinks = [
    { name: '樱花视频', href: '#' },
    { name: '糖豆视频', href: '#' },
    { name: '蘑菇视频', href: '#' },
  ];

  return (
    <footer className="bg-secondary-900 text-background-50" role="contentinfo">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="no-underline" aria-label={t('site.name')}>
              <span className="font-display text-2xl text-background-50">🍑 {t('site.name')}</span>
            </Link>
            <p className="text-secondary-300 text-sm mt-3 leading-relaxed">
              {t('site.description')}
            </p>
            <p className="text-secondary-400 text-xs mt-2">
              {t('site.slogan')}
            </p>
          </div>

          <div>
            <h4 className="text-background-50 text-sm font-semibold mb-4">{t('footer.quickLinks')}</h4>
            <ul className="flex flex-col gap-2.5">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-secondary-300 hover:text-primary-400 text-sm no-underline transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-background-50 text-sm font-semibold mb-4">{t('footer.platforms')}</h4>
            <ul className="flex flex-col gap-2.5">
              {platformLinks.map((p) => (
                <li key={p.name}>
                  <a
                    href={p.href}
                    className="text-secondary-300 hover:text-primary-400 text-sm no-underline transition-colors duration-200"
                    rel="nofollow"
                  >
                    {p.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-background-50 text-sm font-semibold mb-4">{t('footer.contactUs')}</h4>
            <div className="flex flex-col gap-2.5">
              <p className="text-secondary-300 text-sm">
                <i className="ri-mail-line mr-2"></i>contact@huangtao.com
              </p>
              <p className="text-secondary-300 text-sm">
                <i className="ri-wechat-line mr-2"></i>黄桃视频官方
              </p>
              <p className="text-secondary-300 text-sm">
                <i className="ri-map-pin-line mr-2"></i>北京市朝阳区望京科技园
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-secondary-700 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-secondary-400 text-xs">
            © {currentYear} {t('footer.copyright')}
          </p>
          <p className="text-secondary-500 text-xs">
            {t('footer.disclaimer')}
          </p>
        </div>
      </div>
    </footer>
  );
}